import React, {Component} from 'react';
import {Table, Tabs, Tab, Badge} from 'react-bootstrap';
import {loadState} from "../../LocalStore/localStorage";
import {
    accessLogSend,
    getLiveSchedule,
    getOneToManySchedule,
    getOneToOneSchedule
} from "../../redux/actions/instructor";
import {connect} from "react-redux";
import moment from "moment";
import mobileNumberHide from "../../redux/helper/mobileNumberHide";
import Coundown from "../common/Coundown";

class ScheduleType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: loadState('userInfo')
        }
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0);
        const {id, instructor_id, first_name, last_name, mobile_number} = this.state.userInfo;
        await this.props.dispatch(accessLogSend(`${id}|#|${instructor_id}|#|${first_name} ${last_name}|#|${mobile_number}`, 'Tuition Schedule Page'));
        await this.props.dispatch(getOneToOneSchedule(this.state.userInfo.id));
        await this.props.dispatch(getOneToManySchedule(this.state.userInfo.id));

    };

    // // Random component
    // Completionist = () => {
    //     return (
    //         <p>
    //             <span id="date_hours"> 00 </span> : <span id="date_minutes"> 00 </span> : <span
    //             id="date_seconds"> 00 </span>
    //         </p>
    //     )
    // };
    //
    // // Renderer callback with condition
    // renderer = ({hours, minutes, seconds, completed}) => {
    //     if (completed) {
    //         // Render a complete state
    //         return <Completionist />;
    //     } else {
    //         // Render a countdown
    //         return (
    //             <p><span id="date_hours"> {hours} </span> : <span id="date_minutes"> {minutes} </span> : <span
    //                 id="date_seconds"> {seconds} </span></p>
    //         );
    //     }
    // };

    render() {
        const oneToOneItems = this.props.oneToOne;
        const oneToMany = this.props.oneToMany;
        return (
            <div className="mainBody">
                <div className="container">
                    <div className="row">
                        <div className="col-12 rightContent">
                            <div className="rightBodyContent">
                                <h3 className="secTitle text-center">My Schedule Type</h3> <br/><br/>

                                <Tabs defaultActiveKey="One To One" className="ScheduleTab">
                                    <Tab eventKey="One To One" title="One To One">
                                        <div className="bodyTable">
                                            <Table responsive striped hover className="ScheduleTable">
                                                <thead>
                                                <tr>
                                                    <th>#SL</th>
                                                    <th>Tuition Title</th>
                                                    <th>Slot</th>
                                                    <th>Date</th>
                                                    <th>Enrol Info</th>
                                                    <th>Sold</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {(!oneToOneItems || oneToOneItems.length < 1) &&
                                                <tr>
                                                    <td>
                                                        <p className="text text-capitalize text-danger text-center">loading
                                                            ...</p>
                                                    </td>
                                                </tr>
                                                }

                                                {oneToOneItems && oneToOneItems.length > 0 && oneToOneItems.map((item, index) =>
                                                    <tr key={index}>
                                                        <td>{++index}</td>
                                                        <td>{item.tuition_en}</td>
                                                        <td><Badge
                                                            variant="success">{item.start_time} -To- {item.end_time} </Badge>
                                                        </td>
                                                        <td>
                                                            <Badge className="text-uppercase"
                                                                   variant="warning">{item.available_days_in_week}</Badge>
                                                        </td>
                                                        <td>
                                                            <Badge
                                                                variant="primary">{moment(item.start_date).format('LL')} -To- {moment(item.end_date).format('LL')}</Badge>
                                                        </td>
                                                        <td>
                                                            {item.student_msisdn &&
                                                            <>
                                                                <h5>{item.first_name} {item.last_name}</h5>
                                                                <p>{item.student_msisdn ? mobileNumberHide(item.student_msisdn) : ''}</p>
                                                            </>
                                                            }
                                                        </td>
                                                        <td>
                                                            {item.is_sold && <p className="badge badge-info">Sold</p>}
                                                            {!item.is_sold &&
                                                            <p className="badge badge-danger">unsold</p>}
                                                        </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="Group Learning" title="Group Learning">
                                        <div className="bodyTable">
                                            <Table responsive striped hover className="ScheduleTable">
                                                <thead>
                                                <tr>
                                                    <th>#SL</th>
                                                    <th>Tuition Title</th>
                                                    <th>Slot</th>
                                                    <th>Day</th>
                                                    <th>Date</th>
                                                    <th>Countdown</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {oneToMany && oneToMany.length > 0 && oneToMany.map((item, index) =>
                                                    <tr key={index}>
                                                        <td>{++index}</td>
                                                        <td>{item.tuition_en}</td>
                                                        <td><Badge
                                                            variant="success">{item.start_time} -To- {item.end_time} </Badge>
                                                        </td>
                                                        <td>
                                                            <Badge
                                                                variant="danger">{moment.weekdays(moment(item.start_date).day())}</Badge>
                                                        </td>
                                                        <td>
                                                            <Badge
                                                                variant="primary">{moment(item.start_date).format('LL')} -To- {moment(item.end_date).format('LL')}</Badge>
                                                        </td>
                                                        <td>
                                                            {!item.is_live &&
                                                            <Coundown countdown={item.countdown}/>
                                                            }
                                                            {item.is_live &&
                                                            <div className="liveNow">
                                                                <div className="live_icon">
                                                                    <div className="inner"></div>
                                                                </div>
                                                                <p className="live">LIVE</p>
                                                            </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Tab>
                                </Tabs>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    oneToOne: state.oneToOneReducer,
    oneToMany: state.oneToManyReducer
});

export default connect(mapStateToProps)(ScheduleType);